import { __extends } from "tslib";
import { ProductDirectiveBaseController } from '../common/models/product-directive-base.controller';
import { fetchFeatures } from './utilities/fetch-features';
var ProductFeaturesDirectiveController = /** @class */ (function (_super) {
    __extends(ProductFeaturesDirectiveController, _super);
    function ProductFeaturesDirectiveController($scope, $transclude, $element, $q) {
        var _this = _super.call(this, $scope, $transclude, $element) || this;
        _this.$scope = $scope;
        _this.$transclude = $transclude;
        _this.$element = $element;
        _this.$q = $q;
        return _this;
    }
    ProductFeaturesDirectiveController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    ProductFeaturesDirectiveController.prototype.updateFromProduct = function (productId) {
        var _this = this;
        this.transclude();
        this.$q.when(fetchFeatures(productId, this.$scope.pType))
            .then(function (features) {
            _this.$scope.features = features || [];
        });
    };
    ProductFeaturesDirectiveController.$inject = ['$scope', '$transclude', '$element', '$q'];
    return ProductFeaturesDirectiveController;
}(ProductDirectiveBaseController));
export var ProductFeaturesDirective = [
    function () {
        return {
            controller: ProductFeaturesDirectiveController,
            restrict: 'E',
            scope: {
                pId: '<',
                pType: '@',
            },
            transclude: true,
        };
    },
];
